<template>
    
<div>

    <page-padding>
        <spinner v-if="showLoader && !hasCalendar" class="spinner-custom" />
        <div v-if="!showLoader && !hasCalendar">{{$t('language.no_calendar')}}</div>
        <div v-if="hasCalendar">

          <div>
            <div class="calendar-item" v-for="(date,index) in sliceArray(calendar['0calendar'].dates,3)" :key="index">
                <featured-calendar-item class="heading" :title='date.title' text=""/>
                <div>
                  <featured-calendar-item class="item-btn" :key="index" v-for="(item,index) in date.items" :title='getCalendarTime(item)' :text="item.title" :subtitle="item.descr" @click.native="viewCalendarItem(item.id)"/>
                </div>
            </div>
          </div>

          <button-more title="language.view_more_calendar" to="/calendar"/>
        </div>
      </page-padding>

</div>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../../components/PagePadding';
import Spinner from '../../components/Spinner';
import ButtonMore from '../../components/buttons/ButtonMore';
import FeaturedCalendarItem from './FeaturedCalendarItem';


export default {
  name: 'list-calendar-featured',
  props:{
  },
  data:function(){
    return {
      showLoader:false,
    }
  },
  components:{
    PagePadding,
    Spinner,
    ButtonMore,
    FeaturedCalendarItem,
  },
  methods:{
    viewCalendarItem(id){
      this.$router.push({path:'/calendar_item/'+id})
    },
    getCalendarTime(item){
      var start_time=item.start_time ? item.start_time: "";
      var end_time=item.end_time ? item.end_time: "";
      var separator=end_time ? " - " : "";
      return start_time+separator+end_time;
    },
    sliceArray(arr,count){
      if(arr){
        return arr.slice(0,count)
      }else{
        return [];
      }
    }
  },
  computed:{
    ...mapState([
       'calendar','loaded'
       ]),
       hasCalendar:function(){
         if(this.calendar["0calendar"]){
           return this.calendar["0calendar"].dates ? this.calendar["0calendar"].dates.length : false
         }else{
           return false;
         }
       }
  },
  created:function(){
    this.showLoader=true;
    this.$store.dispatch('get_calendar',{store_key:"0calendar",id:0}).then(()=>{
      this.showLoader=false;
    })
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.heading{
  background-color:#EEEEEE;
  padding:10px;
  border-radius:4px;
}
.calendar-item{
 /* none */
}
.calendar-item:first-child{
  margin-top:15px;
}
.calendar-item:last-child{
  margin-bottom:15px;
}

.item-btn{
   border-bottom: 1px solid #DDDDDD;
   padding:25px 0px;
}

.item-btn:first-child{
  border-top: 1px solid #DDDDDD;
  margin-top:15px;
}
.item-btn:last-child{
  margin-bottom:15px;
}


.spinner-custom{
  margin:10px 0;
}
</style>

